<div class="login-text" style="margin-bottom: 8px">Forgot password?</div>

<form [formGroup]="EmailForm">
  <div class="grid">
    <div class="col instruction-text">
      <span
        >To reset your password, type the full email address you use to sign in to your
        account.</span
      >
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="ui-inputgroup">
        <div
          class="ui-float-label login-float"
          [class.float-label]="!!f.emailAddress.value"
          style="flex-grow: 1"
        >
          <input
            size="40"
            id="email"
            name="email"
            type="email"
            autocomplete="off"
            formControlName="emailAddress"
            pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
            required
          />
          <label for="email">Email Address</label>
        </div>
      </div>
    </div>

    <span *ngIf="f?.emailAddress?.invalid && f?.emailAddress?.touched" class="inline-error">
      Please input a valid email.
    </span>
  </div>
  <div class="ui-g-12 control-label">
    <div class="button-container">
      <button
        pButton
        type="button"
        [disabled]="EmailForm.invalid"
        (click)="SendResetLink()"
        class="ui-button-primary"
        label="Send"
      ></button>
      <button
        (click)="Cancel()"
        pButton
        class="ui-button primary"
        type="button"
        label="Cancel"
      ></button>
    </div>
  </div>
</form>
